/* eslint-disable */
import React from "react";
import Button from "@material-ui/core/Button";
import PropTypes from "prop-types";
import "./button.scss";
import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({
  button: {
    margin: theme.spacing(1),
  },
}));
export default function ReuseableButton(props) {
  const classes = useStyles();
  const {
    className,
    text,
    colorVarient,
    startIcon,
    endIcon,
    handleChange,
    disabled,
    fullWidthFlag,
    hasFilter,
    backgroundColor,
    color,
    icon,
    noText,
    height
  } = props;
  return (
    <Button
      data-test="buttonComponent"
      data-testid="buttonComponent"
      className={`${
        hasFilter && "button-red-background"
      } button-${colorVarient} ${classes.button} ${
        className ? className : null
      }`}
      style={{
        background: backgroundColor ? backgroundColor : null,
        color: color ? color : null,
        height: height? height: null,
      }}
      variant="contained"
      startIcon={startIcon}
      endIcon={endIcon}
      onClick={handleChange}
      disabled={disabled}
      size="large"
      fullWidth={fullWidthFlag}
    >
      {noText ? icon : text}
    </Button>
  );
}

ReuseableButton.propTypes = {
  text: PropTypes.string,
  colorVarient: PropTypes.string,
  startIcon: PropTypes.node,
  endIcon: PropTypes.node,
  handleChange: PropTypes.func,
  disabled: PropTypes.bool,
  fullWidthFlag: PropTypes.bool,
  hasFilter: PropTypes.bool,
  backgroundColor: PropTypes.string,
  color: PropTypes.string,
  noText: PropTypes.bool,
  icon: PropTypes.node,
  height: PropTypes?.any
};
